import { Navbar } from "@/components/Navbar";
import { SpanishHero } from "@/components/SpanishHero";
import { SpanishServices } from "@/components/SpanishServices";
import { SpanishWhyUs } from "@/components/SpanishWhyUs";
import { SpanishTestimonials } from "@/components/SpanishTestimonials";
import { SpanishFAQ } from "@/components/SpanishFAQ";
import { SpanishFinalCTA } from "@/components/SpanishFinalCTA";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";
import { StickyBanner } from "@/components/StickyBanner";
import { LocationContext } from "@/lib/locations";
import { WaitlistPopup } from "@/components/WaitlistPopup";

const location = {
  slug: "hayward",
  name: "Hayward",
  type: "city" as const,
  regionSlug: "alameda" as const,
};

const HaywardSpanishPage = () => (
  <LocationContext.Provider value={location}>
    <SEO
      title="Limpieza del Hogar en Hayward, CA | Uplevel Cleaning"
      description="Servicio profesional de limpieza del hogar en Hayward. Precios transparentes, reserva en 60 segundos, garantía de satisfacción del 200%. ¡Reserva ahora!"
      keywords="limpieza del hogar Hayward, servicio de limpieza Hayward CA, limpieza profunda Hayward, mucama Hayward, limpieza residencial Hayward"
      url="https://uplevelcleaning.com/es/hayward"
      locationName="Hayward"
      regionSlug="alameda"
      lang="es"
      includeLocalBusiness
      includeFAQ
      breadcrumbs={[
        { name: "Inicio", url: "/" },
        { name: "Condado de Alameda", url: "/locations/alameda" },
        { name: "Hayward (Español)", url: "/es/hayward" },
      ]}
      reviews={[
        { author: "María G.", rating: 5, reviewBody: "Uplevel limpió mi apartamento en Hayward de arriba a abajo. Quedé encantada con el resultado.", datePublished: "2026-03-05" },
        { author: "José R.", rating: 5, reviewBody: "Precio justo y transparente. El equipo llegó puntual y dejó todo perfecto.", datePublished: "2026-02-14" },
        { author: "Ana P.", rating: 5, reviewBody: "El mejor servicio de limpieza que he contratado en Hayward. Los recomiendo al 100%.", datePublished: "2026-01-30" },
      ]}
    />
    <WaitlistPopup />
    <div className="flex min-h-screen flex-col">
      <StickyBanner />
      <Navbar />
      <main className="flex-1">
        <SpanishHero cityName="Hayward" regionSlug="alameda" />
        <SpanishWhyUs cityName="Hayward" />
        <SpanishServices />
        <SpanishTestimonials region="alameda" />
        <SpanishFAQ cityName="Hayward" />
        <SpanishFinalCTA cityName="Hayward" />
      </main>
      <Footer />
    </div>
  </LocationContext.Provider>
);

export default HaywardSpanishPage;
